import {
    CREATE_FABRIC_INWARD_DETAILS_FAILURE_DK,
    CREATE_FABRIC_INWARD_DETAILS_REQUEST_DK,
    CREATE_FABRIC_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_FABRIC_INWARD_DETAILS_DK,
    DELETE_FABRIC_INWARD_DETAILS_FAILURE_DK,
    DELETE_FABRIC_INWARD_DETAILS_REQUEST_DK,
    DELETE_FABRIC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_FABRIC_INWARD_DETAILS_FAILURE_DK,
    FETCH_FABRIC_INWARD_DETAILS_REQUEST_DK,
    FETCH_FABRIC_INWARD_DETAILS_SUCCESS_DK,
    FABRIC_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_FABRIC_INWARD_DETAILS_FAILURE_DK,
    UPDATE_FABRIC_INWARD_DETAILS_REQUEST_DK,
    UPDATE_FABRIC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE_DK,
    FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_REQUEST_DK,
    FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_SUCCESS_DK,
    FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_FAILURE_DK,
    FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './fabricInwardDetails.actionsType';

export const FABRIC_INWARD_DETAILS_DK = 'fabricInwardDKDetails';

let initialState = {
    loading: false,
    fabricInwardDetailsById: [],
    fabricInwardDetails: [],
    previousGetList: [],

    fabricInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldReceivingRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    isPoDetailsDisabled: false,
    selectedFabricDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let fabricInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_FABRIC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_REQUEST_DK:
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_FABRIC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_FABRIC_INWARD_DETAILS_REQUEST_DK:
        case DELETE_FABRIC_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardDetails: updatePayload
            };
        case FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsById: updatePayload
            };
        case FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case CREATE_FABRIC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: updatePayload,
                fabricInwardDetailsForm: updatePayload
            };
        case UPDATE_FABRIC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: {},
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_FABRIC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false,
                selectedFabricDetails: {}
            };

        case FETCH_FABRIC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_FABRIC_INWARD_DETAILS_PREVIOUS_FAILURE_DK:
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE_DK:
        case CREATE_FABRIC_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_FABRIC_INWARD_DETAILS_FAILURE_DK:
        case DELETE_FABRIC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_FABRIC_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    ...state.fabricInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FABRIC_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false,
                selectedFabricDetails: {}
            };
        default:
            return state;
    }
};
